//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Table from "@/components/FilterTable/Table.vue";

const DEFAULT_FORMAT = (value) => (value ? value : "N/A");

export default {
  name: "TraitsTable",
  props: ["tableClass", "bordered", "data", "recordsTotal", "loading"],
  components: {
    Table,
  },
  data: function () {
    return {
      separator: "horizontal",
      formOpen: this.data.map(() => false),
      popupForm: {},
      columns: [
        {
          name: "code",
          required: false,
          label: "Código",
          align: "left",
          field: (row) => row.code,
          format: DEFAULT_FORMAT,
          sortable: false,
        },
        {
          name: "name",
          required: false,
          label: "Nome",
          align: "left",
          field: (row) => row.name,
          format: DEFAULT_FORMAT,
          sortable: false,
        },
        {
          name: "date",
          required: false,
          align: "left",
          label: "Data",
          field: (row) => row.file_date,
          format: DEFAULT_FORMAT,
          sortable: false,
        },
        {
          name: "origin",
          required: false,
          align: "left",
          label: "Origem",
          field: (row) => row.file_name,
          format: DEFAULT_FORMAT,
          sortable: false,
        },
      ],
    };
  },
  methods: {
    openPopupForm: function (event) {
      let index = this.data.map((i) => i.id).indexOf(event.id);
      this.popupForm = JSON.parse(JSON.stringify(event));
      this.formOpen[index] = true;
    },
    updateCode: function (index) {
      this.data.splice(index, 1, this.popupForm);
      this.$emit("update-code", this.popupForm);
      this.exitModal(index);
    },
    exitModal: function (index) {
      this.popupForm = {};
      this.formOpen[index] = false;
    },
    updateFilter: function (event) {
      this.$emit("filter-changed", event);
    },
  },
};
